// ===== Interfaces =====

import {
    ILinkMetadata,
} from '../interfaces';

const URL_HOSTNAME_REGEX = /(http(s)?:\/\/)|(\/.*){1}/g;

/**
 * Prefers page descriptions for reader-facing link cards and only falls back to
 * URL text when no description exists.
 */
const getLinkPreviewSecondaryText = (
    linkMetadata: ILinkMetadata | null | undefined,
    preferTrimmedUrl = false,
): string | null => {
    const description = `${linkMetadata?.description || ''}`.trim();
    if (description.length > 0) {
        return description;
    }

    const url = `${linkMetadata?.url || ''}`.trim();
    if (url.length === 0) {
        return null;
    }

    if (!preferTrimmedUrl) {
        return url;
    }

    const trimmedUrl = url.replace(URL_HOSTNAME_REGEX, '');
    return trimmedUrl.length > 0
        ? trimmedUrl
        : url;
};

export default getLinkPreviewSecondaryText;
